import { patchAccount } from '#api/accounts';
import { Button, Flex, Input } from '#atoms';
import CheckBoxAtom from '#atoms/Checkbox';
import usePatchCurrentStepMutation from '#hooks/queries/onboard/usePatchCurrentStepMutation';
import usePersonalInfoQuery from '#hooks/queries/onboard/usePersonalInfoQuery';
import { FloatButtonContainer } from '#molecules';
import { useToast } from '#providers/ToastProvider';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import TagManager from 'react-gtm-module';
import { useOnBoardStep } from '../../OnBoardStep.hooks';
import * as S from './styles';

export default function Step2() {
  const { setStep } = useOnBoardStep();
  const { data } = usePersonalInfoQuery();
  const { mutateAsync: patchCurrentStep } = usePatchCurrentStepMutation();

  const { showToast } = useToast();

  const { mutate } = useMutation(['update-nickname'], patchAccount, {
    onSuccess: () => {
      showToast({
        type: 'success',
        message: '닉네임 수정에 성공하였습니다.'
      });
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '닉네임 수정에 실패하였습니다.'
      });
    }
  });

  const [checked, setChecked] = useState(false);
  const [nickname, setNickname] = useState('');

  const handleNext = () => {
    if (checked) {
      mutate({
        nickname
      });
      TagManager.dataLayer({
        dataLayer: {
          event: 'onboarding_info_next_click',
          category: '신규가입 온보딩',
          action: 'onboarding_info_next_click',
          value: 2
        }
      });
    }
    patchCurrentStep(3);
    setStep(3);
  };

  const onNicknameChange = (v: string | number) => {
    if (typeof v == 'number') return;
    setNickname(v);
  };

  const disabled = checked ? !nickname : false;

  return (
    <>
      <S.Wrapper>
        <S.Title>회원에게 보여지는{'\n'}이름을 설정해 주세요</S.Title>
        <S.Description>
          닉네임을 설정하시면 이름 대신 닉네임으로 표시됩니다.
        </S.Description>

        <Flex direction="column" gap={32}>
          <div>
            <Input disabled labelText="이름" type="text" value={data?.name} />
            <div className="flex justify-start mt-12">
              <CheckBoxAtom
                id={'use nickname'}
                label="닉네임 사용하기"
                labelStyle={{
                  color: 'var(--Gray-Scale-500, #948F9E)',
                  textAlign: 'center',
                  fontFamily: 'Pretendard Variable',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '21px', // 131.25%
                  letterSpacing: '-0.32px'
                }}
                checked={checked}
                onClick={() => setChecked(!checked)}
              />
            </div>
          </div>

          {checked && (
            <Input
              labelText="닉네임"
              onChange={onNicknameChange}
              type="text"
              value={nickname}
            />
          )}
        </Flex>
      </S.Wrapper>
      <FloatButtonContainer>
        <Button disabled={disabled} onClick={handleNext}>
          다음으로
        </Button>
      </FloatButtonContainer>
    </>
  );
}
